import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Modal } from "../modal/Modal";
import { CloseButton } from "../input/CloseButton";
import { useForm } from "react-hook-form";
import { Button } from "../input/Button";
import { Column } from "../layout/Column";

import styles from "./ObjectUrlModal.scss";
import { FormattedMessage } from "react-intl";
import { ToggleInput } from "../input/ToggleInput";

export function Modal2DDialog({ onClose, el }) {
  const { handleSubmit } = useForm();

  const [is2D, setIs2D] = useState(false);

  const onSubmit = () => {
    el.components['media-loader'].data.mediaOptions.openAs2D = is2D;
    onClose();
  }


  const toggle2D = () => {
    setIs2D(!is2D);
  };

  return (
    <Modal
      title={<FormattedMessage id="object-2d-modal.title" defaultMessage="View Type" />}
      beforeTitle={<CloseButton onClick={onClose} />}
    >
      <Column as="form" padding center onSubmit={handleSubmit(onSubmit)}>
            <ToggleInput
              className={styles.hideHrefToggleInput}
              name="hideHref"
              label={
                <FormattedMessage
                  id="object-url-modal.hide-href-field-label"
                  defaultMessage="Use object in 2D View"
                />
              }

              description={
                <FormattedMessage
                  id="object-url-modal.hide-href-field-description"
                  defaultMessage="Make Objects be visible in a web 2D UI instead like a 3D Model"
                />
              }

              checked={is2D}
              onChange={toggle2D}
            />

        <Button type="submit" preset="accept">
          <FormattedMessage id="object-url-modal.create-object-button" defaultMessage="Confirm" />
        </Button>
      </Column>
    </Modal>
  );
}